module.exports = "https://dhstatic.bthome.com/prod/web/activity_h5/img/goods_3col.432d882ef87f5289.png";